import React from "react";
import PermissionContainer from "../../../containers/Settings/Permission";

const SettingPermission = () => {
  return <PermissionContainer />;
};

export default SettingPermission;
